import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { fuquayVarinaConfig } from "./data";

export default function FuquayVarinaPage() {
  return <CityPageTemplate config={fuquayVarinaConfig} />;
}